import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFirstModule } from "../provider/invoiceProvider";
import trusted from "../assets/trusted.svg";
import info from "../assets/info.svg";
import lock from "../assets/lock1.svg";
import vampaylogo from "../assets/vampaylogo.svg";
import abLogo from "../assets/vampay.svg";
import CustomInput from "../components/customInput";
import NewCustomInput from "../components/newCustomInput";
import cross from "../assets/closetheme5.svg";
export default function FifthAmountPayable() {
  const { invoiceData } = useFirstModule();

  return (
    <Card
      sx={{
        minWidth: 275,
        borderRadius: 4,
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent>
        <div className="flex items-start justify-between w-full gap-4 ">
          <div className="flex items-center justify-between gap-4">
            <img
              src={invoiceData?.merchant_logo || abLogo}
              alt="logo"
              height={140}
              width={140}
              className="border rounded-lg border-[#250255]  w-10 h-10"
            />
            <div className="text-[#111111] text-[16px] font-bold">
              {invoiceData?.vendor_name}
            </div>
          </div>

          <div className="">
            <img src={cross} alt="logo" height={30} width={30} className="" />
          </div>
        </div>
        <div className="py-4 ">
          <div className="">{/* <img src={} /> */}</div>
          {invoiceData?.payable_amount && (
            <div className="pb-2  heading text-center opacity-75 text-[#4A04AA]">
              <p className="text-[#4A04AA] text-[12px]">Amount payable</p>
            </div>
          )}

          <div className="w-full heading text-wrap ">
            <CustomInput
              inputType="number"
              label="₹"
              value={invoiceData?.payable_amount}
              placeholder="Enter Amount"
              disabled
              customStyle={{ height: 50, fontSize: 30 }}
            />
          </div>

          <div className="mx-4 border-b border-black opacity-20"></div>
        </div>
      </CardContent>
    </Card>
  );
}
